import React, { useEffect, useState } from "react";
import { Box, Link, Paper, TextField, Typography } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { makeStyles } from "@mui/styles";
import { MoneyFormatv3 } from "../../../library/MoneyFormat";
import { useThemes } from "../../../components/Theme/theme";

const useStyles = makeStyles({
  table: {
    "& .MuiTableCell-root": {
      border: "1px solid rgba(224, 224, 224, 1)",
    },
  },
});
const headCell = [
  {
    id: "particulars",
    label: "Particulars",
    width: 100,
    align: "left",
  },
  {
    id: "debit",
    label: "Debit (₹)",
    width: 50,
    align: "right",
  },
  {
    id: "credit",
    label: "Credit (₹)",
    width: 50,
    align: "right",
  },
];
function JournalEntry({
  Type,
  journalEntry,
  totCdtAmt,
  totDbtAmt,
  invTransArr,
  paymentTransArr,
  partyType,
  registrationType,
  modalEvent,
  currencyRate,
  data,
  setData
}) {
  const { theme } = useThemes()

  const classes = useStyles();

  return (
    <Box sx={{ m: 1 ,}}>
      <Box>
        <TableContainer
          className={classes.table}
          aria-setsize="small"
          sx={{
            ".MuiTableContainer-root": {
              overflowY: "scroll",
            },
            width: "100%",
            "&::-webkit-scrollbar": {
              width: "0.4em",
              height: "0.4em",
            },
            maxHeight: modalEvent === false ?
              (Type === "Purchase" || partyType === "SUPPLIER" ? 300 : 200) : (600)
          }}
        >
          <Table
            stickyHeader
            className={classes.table}
            s
            aria-label="simple table"
          >
            <TableHead sx={{ color: "#FFF" }}>
              <TableRow>
                {headCell.map((column, ind) => {
                  return (
                    <TableCell
                      key={ind}
                      width={column.width}
                      align={column.align}
                      sx={{
                        fontWeight: 600,
                        fontSize: "12px",
                        color: "input.label",
                        padding: "5px",
                        backgroundColor: "background.tablebg",
                      }}
                    >
                      {column.label}{" "}
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {/* {invTransArr.length > 0 && (
                <>
                  <TableRow>
                    <TableCell
                      colSpan={3}
                      size="small"
                      sx={{ backgroundColor: "#ece0e63d" }}
                      align="left"
                    >
                      <Link sx={{ color: "primary.main", fontWeight: "bold" }}>
                        {Type === "Sales" 
                          ? "Sales Entry":Type==="Pos"?"Pos Entry"
                          : Type === "DebitNote"
                          ? "Debit Note Entry"
                          : Type === "CreditNote"
                          ? "Credit Note Entry"
                          : "Purchase Entry"}
                      </Link>
                    </TableCell>
                  </TableRow>
                  {registrationType !== 3 ? (
                    invTransArr
                      .sort((p1) =>
                        p1.debitAmt !== 0 ? -1 : p1.creditAmt == 0 ? 0 : 1
                      )
                      .map((ele, ind) => {
                        return (
                          <TableRow key={ind}>
                            {ele.debitAmt == 0 && ele.creditAmt == 0 ? (
                              <></>
                            ) : (
                              <>
                                <TableCell
                                  size="small"
                                  sx={{
                                    fontWeight: "bold",
                                    color:
                                      ele.debitAmt !== 0
                                        ? "#396afc"
                                        : "#20e0cf",
                                    width: "300px",
                                    height: "0px",
                                  }}
                                >
                                  {ele.debitAmt !== 0
                                    ? ele.accountName + " " + "Dr"
                                    : "To" + " " + ele.accountName}
                                </TableCell>
                                <TableCell
                                  align="right"
                                  size="small"
                                  sx={{
                                    fontWeight: "bold",
                                    color: "#396afc",
                                    width: "30px",
                                    height: "0px",
                                  }}
                                >
                                  {ele.debitAmt == 0
                                    ? " "
                                    : MoneyFormatv3(
                                        Number(ele.debitAmt),
                                        "en-IN"
                                      )}
                                </TableCell>
                                <TableCell
                                  align="right"
                                  size="small"
                                  sx={{
                                    fontWeight: "bold",
                                    color: "#20e0cf",
                                    width: "30px",
                                    height: "0px",
                                  }}
                                >
                                  {ele.creditAmt == 0
                                    ? " "
                                    : MoneyFormatv3(
                                        Number(ele.creditAmt),
                                        "en-IN"
                                      )}
                                </TableCell>
                              </>
                            )}
                          </TableRow>
                        );
                      })
                  ) : (
                    <>
                      <>
                        <TableRow>
                          <TableCell
                            colSpan={3}
                            size="small"
                            sx={{ backgroundColor: "#ece0e63d" }}
                            align="left"
                          >
                            <Link
                              sx={{ color: "primary.main", fontWeight: "bold"}}
                            >
                           
                            </Link>
                          </TableCell>
                        </TableRow>
                        {invTransArr
                          .sort((p1) =>
                            p1.debitAmt !== 0 ? -1 : p1.creditAmt == 0 ? 0 : 1
                          )
                          .map((ele, ind) => {
                            if (ele.accID !== 32 && ele.accID !== 33) {
                              return (
                                <TableRow key={ind}>
                                  {ele.debitAmt == 0 && ele.creditAmt == 0 ? (
                                    <></>
                                  ) : (
                                    <>
                                      <TableCell
                                        size="small"
                                        sx={{
                                          fontWeight: "bold",
                                          color:
                                            ele.debitAmt !== 0
                                              ? "#396afc"
                                              : "#20e0cf",
                                          width: "300px",
                                          height: "0px",
                                        }}
                                      >
                                        {ele.debitAmt !== 0
                                          ? ele.accountName + " " + "Dr"
                                          : "To" + " " + ele.accountName}
                                      </TableCell>
                                      <TableCell
                                        align="right"
                                        size="small"
                                        sx={{
                                          fontWeight: "bold",
                                          color: "#396afc",
                                          width: "30px",
                                          height: "0px",
                                        }}
                                      >
                                        {ele.debitAmt == 0
                                          ? " "
                                          : MoneyFormatv3(
                                              Number(ele.debitAmt),
                                              "en-IN"
                                            )}
                                      </TableCell>
                                      <TableCell
                                        align="right"
                                        size="small"
                                        sx={{
                                          fontWeight: "bold",
                                          color: "#20e0cf",
                                          width: "30px",
                                          height: "0px",
                                        }}
                                      >
                                        {ele.creditAmt == 0
                                          ? " "
                                          : MoneyFormatv3(
                                              Number(ele.creditAmt),
                                              "en-IN"
                                            )}
                                      </TableCell>
                                    </>
                                  )}
                                </TableRow>
                              );
                            }
                          })}
                      </>{" "}
                      <>
                        <TableRow>
                          <TableCell
                            colSpan={3}
                            size="small"
                            sx={{ backgroundColor: "#ece0e63d" }}
                            align="left"
                          >
                            <Link
                              sx={{ color: "primary.main", fontWeight: "bold" }}
                            >
                            
                            </Link>
                          </TableCell>
                        </TableRow>
                        {invTransArr
                          .sort((p1) =>
                            p1.debitAmt !== 0 ? -1 : p1.creditAmt == 0 ? 0 : 1
                          )
                          .map((ele, ind) => {
                            if (ele.accID === 32 || ele.accID === 33) {
                              return (
                                <TableRow key={ind}>
                                  {ele.debitAmt == 0 && ele.creditAmt == 0 ? (
                                    <></>
                                  ) : (
                                    <>
                                      <TableCell
                                        size="small"
                                        sx={{
                                          fontWeight: "bold",
                                          color:
                                            ele.debitAmt !== 0
                                              ? "#396afc"
                                              : "#20e0cf",
                                          width: "300px",
                                          height: "0px",
                                        }}
                                      >
                                        {ele.debitAmt !== 0
                                          ? ele.accountName + " " + "Dr"
                                          : "To" + " " + ele.accountName}
                                      </TableCell>
                                      <TableCell
                                        align="right"
                                        size="small"
                                        sx={{
                                          fontWeight: "bold",
                                          color: "#396afc",
                                          width: "30px",
                                          height: "0px",
                                        }}
                                      >
                                        {ele.debitAmt == 0
                                          ? " "
                                          : MoneyFormatv3(
                                              Number(ele.debitAmt),
                                              "en-IN"
                                            )}
                                      </TableCell>
                                      <TableCell
                                        align="right"
                                        size="small"
                                        sx={{
                                          fontWeight: "bold",
                                          color: "#20e0cf",
                                          width: "30px",
                                          height: "0px",
                                        }}
                                      >
                                        {ele.creditAmt == 0
                                          ? " "
                                          : MoneyFormatv3(
                                              Number(ele.creditAmt),
                                              "en-IN"
                                            )}
                                      </TableCell>
                                    </>
                                  )}
                                </TableRow>
                              );
                            }
                          })}
                      </>
                    </>
                  )}
                </>
              )}
              {Type!=="Pos" && paymentTransArr.length > 0 && (
                <>
                  <TableRow>
                    <TableCell
                      size="small"
                      sx={{ backgroundColor: "#ece0e63d" }}
                      colSpan={3}
                      align="left"
                    >
                      <Link sx={{ color: "primary.main", fontWeight: "bold" }}>
                        {Type === "Sales" || Type === "DebitNote"
                          ? "Receipt Entry"
                          : "Payment Entry"}
                      </Link>
                    </TableCell>
                  </TableRow>
                  {paymentTransArr
                    .sort((p1) =>
                      p1.debitAmt !== 0 ? -1 : p1.creditAmt == 0 ? 0 : 1
                    )
                    .map((ele, ind) => {
                      return (
                        <TableRow key={ind}>
                          {ele.debitAmt == 0 && ele.creditAmt == 0 ? (
                            <></>
                          ) : (
                            <>
                              <TableCell
                                size="small"
                                sx={{
                                  fontWeight: "bold",
                                  color:
                                    ele.debitAmt !== 0 ? "#396afc" : "#20e0cf",
                                  width: "300px",
                                  height: "0px",
                                }}
                              >
                                {ele.debitAmt !== 0
                                  ? ele.accountName + " " + "Dr"
                                  : "To" + " " + ele.accountName}
                              </TableCell>
                              <TableCell
                                size="small"
                                align="right"
                                sx={{
                                  fontWeight: "bold",
                                  color: "#396afc",
                                  width: "30px",
                                  height: "0px",
                                }}
                              >
                                {ele.debitAmt == 0
                                  ? " "
                                  : MoneyFormatv3(
                                      Number(ele.debitAmt),
                                      "en-IN"
                                    )}
                              </TableCell>
                              <TableCell
                                align="right"
                                size="small"
                                sx={{
                                  fontWeight: "bold",
                                  color: "#20e0cf",
                                  width: "30px",
                                  height: "0px",
                                }}
                              >
                                {ele.creditAmt == 0
                                  ? " "
                                  : MoneyFormatv3(
                                      Number(ele.creditAmt),
                                      "en-IN"
                                    )}
                              </TableCell>
                            </>
                          )}
                        </TableRow>
                      );
                    })}
                </>
              )} */}
              {invTransArr.length > 0 && (
                <>
                  <TableRow>
                    <TableCell
                      colSpan={3}
                      size="small"
                      sx={{ backgroundColor: "#ece0e63d" }}
                      align="left"
                    >
                      <Link id="editN" sx={{ color: "primary.main", fontWeight: "bold" }}>
                        {Type === "Sales"
                          ? "Sales Entry"
                          : Type === "Pos"
                            ? "Pos Entry"
                            : Type === "DebitNote"
                              ? "Debit Note Entry"
                              : Type === "CreditNote"
                                ? "Credit Note Entry"
                                : "Purchase Entry"}
                      </Link>
                    </TableCell>
                  </TableRow>
                  {registrationType !== 3 ? (
                    invTransArr
                      .sort((p1, p2) => {
                        if (p1.debitAmt !== 0 && p2.debitAmt === 0) return -1;
                        if (p1.debitAmt === 0 && p2.debitAmt !== 0) return 1;
                        return (
                          Math.max(p2.debitAmt, p2.creditAmt) -
                          Math.max(p1.debitAmt, p1.creditAmt)
                        );
                      })
                      .map((ele, ind) => (
                        <TableRow key={ind}>
                          {ele.debitAmt == 0 && ele.creditAmt == 0 ? (
                            <></>
                          ) : (
                            <>
                              <TableCell
                                size="small"
                                sx={{
                                  fontWeight: "bold",
                                  color:
                                    ele.debitAmt !== 0 ? "#396afc" : "#20e0cf",
                                  width: "300px",
                                  height: "0px",
                                }}
                              >
                                {ele.debitAmt !== 0
                                  ? ele.accountName + " " + "Dr"
                                  : "To" + " " + ele.accountName}
                              </TableCell>
                              <TableCell
                                align="right"
                                size="small"
                                sx={{
                                  fontWeight: "bold",
                                  color: "#396afc",
                                  width: "30px",
                                  height: "0px",
                                }}
                              >
                                {ele.debitAmt == 0
                                  ? " "
                                  : MoneyFormatv3(
                                    Number(ele.debitAmt),
                                    "en-IN"
                                  )}
                              </TableCell>
                              <TableCell
                                align="right"
                                size="small"
                                sx={{
                                  fontWeight: "bold",
                                  color: "#20e0cf",
                                  width: "30px",
                                  height: "0px",
                                }}
                              >
                                {ele.creditAmt == 0
                                  ? " "
                                  : MoneyFormatv3(
                                    Number(ele.creditAmt),
                                    "en-IN"
                                  )}
                              </TableCell>
                            </>
                          )}
                        </TableRow>
                      ))
                  ) : (
                    <>
                      {/* Similar sorting and mapping for registrationType === 3 */}
                      <>
                        <>
                          <TableRow>
                            <TableCell
                              colSpan={3}
                              size="small"
                              sx={{ backgroundColor: "#ece0e63d" }}
                              align="left"
                            >
                              <Link
                                sx={{ color: "primary.main", fontWeight: "bold" }}
                              >

                              </Link>
                            </TableCell>
                          </TableRow>
                          {invTransArr
                            .sort((p1, p2) => {
                              if (p1.debitAmt !== 0 && p2.debitAmt === 0) return -1;
                              if (p1.debitAmt === 0 && p2.debitAmt !== 0) return 1;
                              return (
                                Math.max(p2.debitAmt, p2.creditAmt) -
                                Math.max(p1.debitAmt, p1.creditAmt)
                              );
                            })
                            .map((ele, ind) => {
                              if (ele.accID !== 32 && ele.accID !== 33 && ele.accID !== 64 && ele.accID !== 65) {
                                return (
                                  <TableRow key={ind}>
                                    {ele.debitAmt == 0 && ele.creditAmt == 0 ? (
                                      <></>
                                    ) : (
                                      <>
                                        <TableCell
                                          size="small"
                                          sx={{
                                            fontWeight: "bold",
                                            color:
                                              ele.debitAmt !== 0
                                                ? "#396afc"
                                                : "#20e0cf",
                                            width: "300px",
                                            height: "0px",
                                          }}
                                        >
                                          {ele.debitAmt !== 0
                                            ? ele.accountName + " " + "Dr"
                                            : "To" + " " + ele.accountName}
                                        </TableCell>
                                        <TableCell
                                          align="right"
                                          size="small"
                                          sx={{
                                            fontWeight: "bold",
                                            color: "#396afc",
                                            width: "30px",
                                            height: "0px",
                                          }}
                                        >
                                          {ele.debitAmt == 0
                                            ? " "
                                            : MoneyFormatv3(
                                              Number(ele.debitAmt),
                                              "en-IN"
                                            )}
                                        </TableCell>
                                        <TableCell
                                          align="right"
                                          size="small"
                                          sx={{
                                            fontWeight: "bold",
                                            color: "#20e0cf",
                                            width: "30px",
                                            height: "0px",
                                          }}
                                        >
                                          {ele.creditAmt == 0
                                            ? " "
                                            : MoneyFormatv3(
                                              Number(ele.creditAmt),
                                              "en-IN"
                                            )}
                                        </TableCell>
                                      </>
                                    )}
                                  </TableRow>
                                );
                              }
                            })}
                        </>{" "}
                        <>
                          <TableRow>
                            <TableCell
                              colSpan={3}
                              size="small"
                              sx={{ backgroundColor: "#ece0e63d" }}
                              align="left"
                            >
                              <Link
                                sx={{ color: "primary.main", fontWeight: "bold" }}
                              >

                              </Link>
                            </TableCell>
                          </TableRow>
                          {invTransArr
                            .sort((p1) =>
                              p1.debitAmt !== 0 ? -1 : p1.creditAmt == 0 ? 0 : 1
                            )
                            .map((ele, ind) => {
                              if (ele.accID === 32 || ele.accID === 33 || ele?.accID===64 || ele?.accID===65) {
                                return (
                                  <TableRow key={ind}>
                                    {ele.debitAmt == 0 && ele.creditAmt == 0 ? (
                                      <></>
                                    ) : (
                                      <>
                                        <TableCell
                                          size="small"
                                          sx={{
                                            fontWeight: "bold",
                                            color:
                                              ele.debitAmt !== 0
                                                ? "#396afc"
                                                : "#20e0cf",
                                            width: "300px",
                                            height: "0px",
                                          }}
                                        >
                                          {ele.debitAmt !== 0
                                            ? ele.accountName + " " + "Dr"
                                            : "To" + " " + ele.accountName}
                                        </TableCell>
                                        <TableCell
                                          align="right"
                                          size="small"
                                          sx={{
                                            fontWeight: "bold",
                                            color: "#396afc",
                                            width: "30px",
                                            height: "0px",
                                          }}
                                        >
                                          {ele.debitAmt == 0
                                            ? " "
                                            : MoneyFormatv3(
                                              Number(ele.debitAmt),
                                              "en-IN"
                                            )}
                                        </TableCell>
                                        <TableCell
                                          align="right"
                                          size="small"
                                          sx={{
                                            fontWeight: "bold",
                                            color: "#20e0cf",
                                            width: "30px",
                                            height: "0px",
                                          }}
                                        >
                                          {ele.creditAmt == 0
                                            ? " "
                                            : MoneyFormatv3(
                                              Number(ele.creditAmt),
                                              "en-IN"
                                            )}
                                        </TableCell>
                                      </>
                                    )}
                                  </TableRow>
                                );
                              }
                            })}
                        </>
                      </>
                    </>
                  )}
                </>
              )}

              {Type !== "Pos" && paymentTransArr.length > 0 && (
                <>
                  <TableRow>
                    <TableCell
                      size="small"
                      sx={{ backgroundColor: "#ece0e63d" }}
                      colSpan={3}
                      align="left"
                    >
                      <Link sx={{ color: "primary.main", fontWeight: "bold" }}>
                        {Type === "Sales" || Type === "DebitNote"
                          ? "Receipt Entry"
                          : "Payment Entry"}
                      </Link>
                    </TableCell>
                  </TableRow>
                  {paymentTransArr
                    .sort((p1, p2) => {
                      if (p1.debitAmt !== 0 && p2.debitAmt === 0) return -1;
                      if (p1.debitAmt === 0 && p2.debitAmt !== 0) return 1;
                      return (
                        Math.max(p2.debitAmt, p2.creditAmt) -
                        Math.max(p1.debitAmt, p1.creditAmt)
                      );
                    })
                    .map((ele, ind) => (
                      <TableRow key={ind}>
                        {ele.debitAmt == 0 && ele.creditAmt == 0 ? (
                          <></>
                        ) : (
                          <>
                            <TableCell
                              size="small"
                              sx={{
                                fontWeight: "bold",
                                color:
                                  ele.debitAmt !== 0 ? "#396afc" : "#20e0cf",
                                width: "300px",
                                height: "0px",
                              }}
                            >
                              {ele.debitAmt !== 0
                                ? ele.accountName + " " + "Dr"
                                : "To" + " " + ele.accountName}
                            </TableCell>
                            <TableCell
                              size="small"
                              align="right"
                              sx={{
                                fontWeight: "bold",
                                color: "#396afc",
                                width: "30px",
                                height: "0px",
                              }}
                            >
                              {ele.debitAmt == 0
                                ? " "
                                : MoneyFormatv3(Number(ele.debitAmt), "en-IN")}
                            </TableCell>
                            <TableCell
                              align="right"
                              size="small"
                              sx={{
                                fontWeight: "bold",
                                color: "#20e0cf",
                                width: "30px",
                                height: "0px",
                              }}
                            >
                              {ele.creditAmt == 0
                                ? " "
                                : MoneyFormatv3(Number(ele.creditAmt), "en-IN")}
                            </TableCell>
                          </>
                        )}
                      </TableRow>
                    ))}
                </>
              )}
              {totCdtAmt > 0 && totDbtAmt > 0 && (
                <TableRow>
                  <TableCell size="small" sx={{ fontWeight: "bold" }}>
                    Total (₹)
                  </TableCell>
                  <TableCell align="right" sx={{ fontWeight: "bold" }}>
                    {MoneyFormatv3(Number(totDbtAmt), "en-IN")}
                  </TableCell>
                  <TableCell align="right" sx={{ fontWeight: "bold" }}>
                    {MoneyFormatv3(Number(totCdtAmt), "en-IN")}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
}

export default JournalEntry;
